import FilePicker from './file_picker';

export default FilePicker;
